import * as React from 'react';

import {DynamicStatusButton} from 'shells/button/dynamic-status-button/dynamic-status-button';

import type {EmailStats as EmailStatsFragment} from 'nutshell-graphql-types';

import {EmailStatusEmptyState} from './email-status-empty-state';
import {EmailStatusHeaderContent} from './email-status-header-content';
import {EmailStatusPopoverContent} from './email-status-popover-content';

type Props = {
    emailStats: EmailStatsFragment | null | undefined;
};

export function EmailStatusButton(props: Props) {
    const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);

    if (!props.emailStats) return null;

    const handlePopoverBlur = () => {
        setIsDialogOpen(false);
    };

    return (
        <DynamicStatusButton
            text={props.emailStats.summary}
            isDialogOpen={isDialogOpen && Boolean(props.emailStats)}
            setIsDialogOpen={setIsDialogOpen}
            headerType={props.emailStats.status || 'info'}
            headerContent={
                props.emailStats.status ? (
                    <EmailStatusHeaderContent emailStats={props.emailStats} />
                ) : undefined
            }
            popoverContent={
                props.emailStats.status ? (
                    <EmailStatusPopoverContent emailStats={props.emailStats} />
                ) : (
                    <EmailStatusEmptyState
                        emailStats={props.emailStats}
                        handlePopoverBlur={handlePopoverBlur}
                    />
                )
            }
        />
    );
}
